<template>
  <div class="bonuses-info" v-if="isBonusesInfo">
    <div class="bonuses-item" v-if="bonusesInfo.current_purchase_bonuses && !(promocodeInfo && promocodeInfo.codeValue)">
      <span class="bonuses-item__title">{{ $t('cart.order_bonuses') }}</span>
      <span class="bonuses-item__number">
        {{ bonusesInfo.current_purchase_bonuses }}
      </span>
    </div>
    <div class="bonuses-item" v-if="bonusesInfo.current_rate && !(promocodeInfo && promocodeInfo.codeValue)">
      <span class="bonuses-item__title">{{ $t('cart.current_bonuses_percent') }}</span>
      <span class="bonuses-item__number">
        {{ bonusesInfo.current_rate }}
      </span>
    </div>
    <!--    Проверка на ставку 30% для сотрудников компании-->
    <div class="bonuses-item--next-rate" v-if="showNextRateInfo">
      <span>{{ $t('next-bonus') }}</span>
      <span> {{ bonusesInfo.next_rate }}%</span>
      <span> {{ $t('left') }} </span>
      <span class="bonuses-item__accent">{{ bonusesInfo.until_next_bonus_rate }}</span>
    </div>
    <Loader v-if="showLoader" :is-loading="!!loadingComponents.bonusesInModal"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loader from '../helpers/Loader'
import CurrencyFormatter from '../../filters/CurrencyFormatter'
import Pluralize from '../../filters/Pluralize'

export default {
  name: 'BonusesInModal',
  components: { Loader },
  computed: {
    ...mapState({
      bonusesInfo: state => state.bonuses.bonusesInfo,
      loadingComponents: state => state.checkout.loadingComponents,
      promocodeInfo: state => state.cart.promocodeInfo
    }),
    isBonusesInfo () {
      return this.bonusesInfo && this.bonusesInfo.is_active_bonuses_info
    },
    showLoader () {
      return this.bonusesInfo.current_purchase_bonuses || (this.bonusesInfo.rate && this.bonusesInfo.rate !== this.bonusesInfo.next_rate)
    },
    showNextRateInfo () {
      return this.bonusesInfo.rate && this.bonusesInfo.rate !== this.bonusesInfo.next_rate && this.bonusesInfo.next_rate !== 0 && this.bonusesInfo.next_rate !== null
    }
  },
  filters: {
    CurrencyFormatter,
    Pluralize
  }
}
</script>

<style scoped lang="sass">

.bonuses-info
  position: relative
  width: 100%
  margin-bottom: 30px

.bonuses-item
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  font-size: 16px
  line-height: 20px
  color: $text-color

  &:not(:last-child)
    margin-bottom: 5px

  &--next-rate
    font-size: 14px
    color: $nd-label-color
    line-height: 1.5
    margin-top: 20px

  &__accent
    white-space: nowrap

.bonuses-item__info
  color: $nd-label-color
  font-weight: 400 //Rubik 300

.bonuses-item__number
  min-width: 100px
  text-align: right
</style>
